function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";
import { Resource } from "react-admin";
import { useGetCanActivate } from "../../hooks/use-get-can-activate.js";
export const RbacResource = (_ref) => {
  let {
    name,
    list,
    edit,
    show,
    create
  } = _ref,
      rest = _objectWithoutProperties(_ref, ["name", "list", "edit", "show", "create"]);

  const {
    loaded,
    canActivate
  } = useGetCanActivate();

  if (!loaded && !canActivate) {
    return null;
  }

  return /*#__PURE__*/React.createElement(Resource, _extends({}, rest, {
    create: canActivate(name, "create") && create,
    edit: canActivate(name, "edit") && edit,
    show: canActivate(name, "show") && show,
    list: canActivate(name, "list") && list,
    name: name
  }));
};
RbacResource.displayName = "RbacResource";